var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{staticClass:"page__equipment"},[_c('PageRow',[_c('VCol',{attrs:{"cols":"12"}},[_c('EquipmentDevices')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }